/**
 * Copyright (c) 2010-2021 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { LocalStorageProxy } from '../../modules/shared/local-storage-shim';
import { Injectable, Injector } from '@angular/core';
import { LoggerService } from '../../modules/shared/services/logger.service';
import { DashGisUtil } from '../../modules/shared/dash-gis-util';

@Injectable()
export class OpenIdStorageShim extends LocalStorageProxy {
    private superPrefix: string;
    constructor() {
        super();
        this.superPrefix = this.prefix;
        this.prefix += '_oidc';
        this.rememberBasedKeys.push('access_token', 'id_token', 'refresh_token');
    }

    getItem(key: any): any {
        const rememberString = localStorage.getItem(this.superPrefixedKey('auth.remember'));
        const remember = DashGisUtil.parseBoolean(rememberString);
        return this.getItemInternal(key, remember);
    }

    setItem(key: string, val: any): void {
        const rememberString = localStorage.getItem(this.superPrefixedKey('auth.remember'));
        const remember = DashGisUtil.parseBoolean(rememberString);
        this.setItemInternal(key, val, remember);
    }

    private superPrefixedKey(key: string): string {
        return `${this.superPrefix}_${key}`;
    }
}
